import { Section } from "./style";
import { AiOutlineWhatsApp, AiOutlineLinkedin } from "react-icons/ai";
export default function FixedSocial() {
  const linksIcons = [
    {
      link: "https://api.whatsapp.com/send?phone=5511912076607",
      icons: <AiOutlineWhatsApp className="icon" />,
      id: 3,
    },

    // {
    //   link: "https://www.tiktok.com/@drakemisalami",
    //   icons: <AiOutlineLinkedin className="icon" />,
    //   id: 5,
    // },
  ];
  return (
    <Section>
      <div className="sociaLinks column">
        {linksIcons.map((item) => (
          <a key={item.id} href={item.link} target="blanked">
            {item.icons}
          </a>
        ))}
        <hr />
      </div>
    </Section>
  );
}
